import DefaultContentRenderer from 'components/generic/Drawer/components/DefaultContentRenderer';
import DrawerView from 'components/generic/Drawer/DrawerView';
import Content from './Content';
import Footer from './Footer';
import Header from './Header';

type ComAIDrawerViewProps = {
    drawerId: string;
};

const ComAIDrawerView: React.FC<ComAIDrawerViewProps> = ({ drawerId }) => {
    return (
        <DrawerView
            id={drawerId}
            position="right"
            fullscreen
            headerRenderer={() => <Header />}
            footerRenderer={() => <Footer />}
            contentRenderer={(props) => <DefaultContentRenderer.NoPadding {...props} />}
        >
            <Content />
        </DrawerView>
    );
};

export default ComAIDrawerView;
